import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { ClientService } from '../../core/services/client.service';
import { TransferState, makeStateKey } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';

const SERVICES_KEY = makeStateKey('services');

@Component({
  selector: 'app-client-services',
  templateUrl: './client-services.component.html',
  styleUrls: ['./client-services.component.scss'],
})
export class ClientServicesComponent implements OnInit, OnDestroy {
  @Input() store;
  @Input() merchant;
  @Input() preselectedProviderId;
  @Output() saved = new EventEmitter();

  public getStoreServicesSubscription: Subscription;

  public services;
  public loading = true;

  public isBrowser;

  constructor(private clientService: ClientService, private state: TransferState, @Inject(PLATFORM_ID) protected platformId) {}

  get selectedServices(): any {
    return this.services.filter((service) => service.checked === true);
  }

  ngOnInit() {
    this.isBrowser = isPlatformBrowser(this.platformId);

    const serverState = this.state.get(SERVICES_KEY, null as any);

    if (!serverState) {
      this.getStoreServicesSubscription = this.clientService
        .getStoreServices(this.store?.id, this.preselectedProviderId, true)
        .subscribe((res) => {
          this.state.set(SERVICES_KEY, res as any);
          this.services = this.groupAndFilterEmptyCategories(res);
          this.loading = false;
        });
    } else {
      this.services = this.groupAndFilterEmptyCategories(serverState);
      this.loading = false;
    }
  }

  groupAndFilterEmptyCategories(services) {
    let lastCategoryId = null;

    // filter services that should not be shown on the booking page
    services = services.filter(service => service.showOnBookingPage);

    services = services.map(service => {
      if (service.category) {
        service.collapsed = !this.merchant.serviceCategoryExpanded;
        lastCategoryId = service.id;
      } else {
        service.categoryId = lastCategoryId;
      }
      return service;
    });
    return services.filter((v, i) => {
      if (v.category && (!services[i + 1] || services[i + 1].category)) {
        return false;
      }
      return true;
    });
  }

  selectService(service) {
    if (this.store.multipleBookings) {
      service.checked = !service.checked;
    } else {
      this.saved.emit([service]);
    }
  }

  saveMultiSelection() {
    this.saved.emit(this.selectedServices);
  }

  toggleCategory(service) {
    service.collapsed = !service.collapsed;
  }

  isServiceCollapsed(categoryId) {
    return this.services.find(serv => serv.id === categoryId)?.collapsed;
  }

  ngOnDestroy() {
    if (this.isBrowser) {
      this.state.remove(SERVICES_KEY);
    }
    if (this.getStoreServicesSubscription) {
      this.getStoreServicesSubscription.unsubscribe();
    }
  }
}
